var map = {
	"./1/1.jpg": 5838,
	"./2/1.jpg": 7819,
	"./3/1.jpg": 3545,
	"./4/1.jpg": 1043,
	"./5/1.jpg": 2859,
	"./6/1.jpg": 9122,
	"./7/1.jpg": 6608,
	"./8/1.jpg": 9082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 388;